module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"iAMSmartContinue":"Continue to use Electronic Submission Hub"},"zh_hk":{"iAMSmartContinue":"繼續使用[電子資料呈交及處理系統]"},"zh_cn":{"iAMSmartContinue":"继续使用[电子资料呈交及处理系统]"}}')
  delete Component.options._Ctor
}
